import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import * as Constants from '../globals/constants';

@Injectable({
  providedIn: 'root'
})
export class PopulationService {

  public population: number;
  public availableJobs: number;
  public populationUpdate: BehaviorSubject<any>;
  private previousEfficiency;

  constructor() {
    this.population = 0;
    this.availableJobs = 0;
    this.populationUpdate = new BehaviorSubject(1);
  }

  public addPopulation(population) {
    this.population += population;
    this.update();
  }

  public setPopulation(population) {
    this.population = population;
    this.update();
  }

  public getPopulation() {
    return this.population;
  }

  public addAvailableJobs(jobs) {
    this.availableJobs += jobs;
    this.update();
  }

  public setAvailableJobs(jobs) {
    this.availableJobs = jobs;
    this.update();
  }

  public getAvailableJobs(jobs) {
    return this.availableJobs;
  }

  private calculateEfficiency() {
    let efficiency = this.population / this.availableJobs;
    if (!isFinite(efficiency)) {
      efficiency = 0;
    }

    if (efficiency > Constants.SETTINGS.POPULATION.MAX_EFFICIENCY) {
      efficiency = Constants.SETTINGS.POPULATION.MAX_EFFICIENCY;
    }

    return efficiency;
  }

  private update() {
    const efficiency = this.calculateEfficiency();
    if (this.previousEfficiency !== efficiency) {
      this.previousEfficiency = efficiency;
      this.populationUpdate.next(efficiency);
    }
  }

  public reset() {
    this.population = 0;
    this.availableJobs = 0;
    this.update();
  }
}
